module.exports = __webpack_public_path__ + "static/media/infoJumbo1.e5c75535.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/msmarking/images/infoJumbo1.jpg
// module id = 525
// module chunks = 0